import { MapsAPILoader } from '@agm/core';
import { Injectable, Injector } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { HttpService } from '../http.service';
import { switchMap } from 'rxjs/operators';

/*/// <reference types="googlemaps" />*/

@Injectable()
export class GmapsService extends HttpService {

	constructor(
		protected injector: Injector,
		private mapsAPILoader: MapsAPILoader
	) {
		super(injector);
	}

	getGeolocation(address: string): Observable<google.maps.GeocoderResult[]> {
		// tslint:disable-next-line: deprecation
		return Observable.create(observer => {
			this.mapsAPILoader.load().then(() => {
				const geocoder = new google.maps.Geocoder()
				geocoder.geocode({
					address
				}, (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
					observer.next(results);
					observer.complete();
				})
			})
		})
	}

	getAddress(lat: number, lng: number): Observable<google.maps.GeocoderResult[]> {
		// tslint:disable-next-line: deprecation
		return Observable.create(observer => {
			this.mapsAPILoader.load().then(() => {
				const latLng = new google.maps.LatLng(lat, lng)
				const geocoder = new google.maps.Geocoder()
				geocoder.geocode({
					location: latLng
				}, (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
					observer.next(results);
					observer.complete();
				})
			})
		})
	}

	// getTestValue(n: number): number {
	// 	return n * 2
	// }

	// getObservableValue(n: number): Observable<number> {

	// 	return timer(2000).pipe(
	// 		switchMap( () => of(n * 2))
	// 	)
	// }
}